import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getReferidos,
  createReferidoLote,
} from "../../Services/referidos_service";
import { setModal, setToast, setLoading } from "../uiSlice";
import { setResponse } from "../Response/responseSlice";
import { TOAST_DELAY } from "../../Constantes/constants";
import { exportJsonToExcel } from "../../Hooks/exportToExcel";

const initialState = {
  referidos: [],
  referido: {
    dpi: "",
    nombres: "",
    apellidos: "",
    telefono: "",
    idDepartamento: 0,
    idMunicipio: 0,
    idSucursal: 0,
  },
};

export const referidosSlice = createSlice({
  name: "referidos",
  initialState,
  reducers: {
    setReferidos: (state, action) => {
      state.referidos = action.payload;
    },
    setReferido: (state, action) => {
      state.referido = !action.payload ? initialState.referido : action.payload;
    },
  },
});

export const fetchReferidos = createAsyncThunk(
  "referidos/fetchReferidos",
  async (data, { dispatch }) => {
    const referidosRes = await getReferidos(data);
    dispatch(setReferidos(referidosRes));
  }
);

export const postReferidosLote = createAsyncThunk(
  "referidos/postReferidosLote",
  async ({ payload, fechaInicio, fechaFin }, { dispatch }) => {
    dispatch(setLoading(true));
    const response = await createReferidoLote(payload);

    if (!response?.result) {
      dispatch(
        setResponse({
          message: response?.message || "Error al generar el reporte",
          result: false,
        })
      );
      dispatch(setToast(true));
      setTimeout(() => {
        dispatch(setToast(false));
      }, TOAST_DELAY);
      dispatch(setLoading(false));
      return;
    }

    dispatch(setResponse(response));
    dispatch(setToast(true));
    setTimeout(() => {
      dispatch(setToast(false));
    }, TOAST_DELAY);

    const formatFecha = (fecha) => {
      const date = new Date(fecha + "T00:00:00");
      return date.toLocaleDateString("es-GT", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    };

    const fechaInicioFormateada = formatFecha(fechaInicio);
    const fechaFinFormateada = formatFecha(fechaFin);
    const fileName = `REFERIDOS_${fechaInicioFormateada}_${fechaFinFormateada}`;
    exportJsonToExcel(fileName, response.data || []);

    await dispatch(fetchReferidos({ fechaInicio, fechaFin }));

    dispatch(setModal(false));
    dispatch(setLoading(false));
  }
);

export const { setReferidos, setReferido } = referidosSlice.actions;
export default referidosSlice.reducer;
